import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { AddFlow } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const AddFlowPage: FC = () => {
  const { accessToAddFlow } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToAddFlow}>
      <CabinetTitlePage title={'Flows'} goBack={'/cabinet/facebook/flows'} />
      <AddFlow />
    </Guard>
  );
};

export default AddFlowPage;
